import AthleticsBlack from '@assets/Athletics Cuemath/Athletics Black/Athletics-Black.otf';
import AthleticsBold from '@assets/Athletics Cuemath/Athletics Bold/Athletics-Bold.otf';
import AthleticsRegular from '@assets/Athletics Cuemath/Athletics Regular/Athletics-Regular.otf';
import UntitledSansMedium from '@assets/UntitledSans Cuemath/UntitledSans-Medium.ttf';
import UntitledSansRegular from '@assets/UntitledSans Cuemath/UntitledSans-Regular.ttf';

export async function loadFonts() {
  const fonts = [
    // If the font is not working, just remove the weight and try again.
    new FontFace('Athletics-Bold', `url(${AthleticsBold}) format('opentype')`, {
      weight: '28.8',
    }),
    new FontFace('Athletics-Regular', `url(${AthleticsRegular}) format('opentype')`),
    new FontFace('Athletics-Black', `url(${AthleticsBlack}) format('opentype')`),
    new FontFace('UntitledSans-Medium', `url(${UntitledSansMedium}) format('truetype')`),
    new FontFace('UntitledSans-Regular', `url(${UntitledSansRegular}) format('truetype')`),
  ];
  await Promise.all(fonts.map(font => font.load()));
  fonts.forEach(font => document.fonts.add(font));
}
